import Card from '@mui/material/Card';
import { SxProps } from '@mui/material/styles';
import { Theme } from '@mui/system';
import type { ReactNode } from 'react';

interface SharedTabCardProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export default function SharedTabCard({ children, sx }: SharedTabCardProps) {
  return (
    <Card
      sx={{
        width: '100%',
        borderRadius: '8px 8px 0px 0px',
        borderBottom: 0,
        border: (theme) =>
          theme.palette.mode === 'dark'
            ? `0.5px solid ${theme.palette.semantic.outline.light}`
            : 0,
        ...sx,
      }}
    >
      {children}
    </Card>
  );
}
